import type { ClientConfig } from '@n3oltd/karakoram.users.sdk.users'
import { N3O_APP_ID } from '@/lib/auth'

export function createConfig(token: string, subscriptionCode: string = ''): ClientConfig {
  return {
    getBearerToken: () => token,
    getSubscriptionId: () => subscriptionCode,
    getAppId: () => N3O_APP_ID,
  }
}
